import declare from "dojo/_base/declare";
import WizardWidget from "csi/wizard/Widget";

const NewPackListWizard = declare(WizardWidget, {

	/**
	 * If Shipment preselected, don't allow selection of first page in left pane
	 * @override
	 */
	onSelectStep(selectedIndex) {
		// TODO: need to fix typing here
		const controller = this.getSourceController() as any;
		if (selectedIndex == 0 && controller.shipmentSelected) {
			return;
		}

		this.inherited(arguments);
	},
});

export = NewPackListWizard;